module.exports = __webpack_public_path__ + "static/media/default-avatar.747800c7.png";